import { render, staticRenderFns } from "./inspectrecord.vue?vue&type=template&id=70672c0d&scoped=true&"
import script from "./inspectrecord.vue?vue&type=script&lang=js&"
export * from "./inspectrecord.vue?vue&type=script&lang=js&"
import style0 from "./inspectrecord.vue?vue&type=style&index=0&id=70672c0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70672c0d",
  null
  
)

export default component.exports